import React, { createContext, useContext, useState, useEffect, useRef, ReactNode } from "react";

interface SidebarContextType {
  isCollapsed: boolean;
  setIsCollapsed: (collapsed: boolean) => void;
  toggleCollapsed: () => void;
  sidebarWidth: string;
  hasInitialized: boolean;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);
  const isFirstMount = useRef(true);

  useEffect(() => {
    // Mark as initialized after first render to skip animations on navigation
    if (isFirstMount.current) {
      isFirstMount.current = false;
      // Small delay to let initial animations complete
      const timer = setTimeout(() => {
        setHasInitialized(true);
      }, 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const toggleCollapsed = () => setIsCollapsed(prev => !prev);
  const sidebarWidth = isCollapsed ? "80px" : "280px";

  return (
    <SidebarContext.Provider value={{ isCollapsed, setIsCollapsed, toggleCollapsed, sidebarWidth, hasInitialized }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = (): SidebarContextType => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};



